export default {
  admin: {
    users: {},
  },
}